import { fetchAuthSession, getCurrentUser } from "aws-amplify/auth";
import { jwtDecode } from "jwt-decode";

export const getUserType = () => {
  const userType = localStorage.getItem("userType");
  return userType;
};

export async function currentAuthenticatedUser() {
  try {
    let session = await currentSession();
    if (!session) {
      return null;
    }
    const { username, userId, signInDetails } = await getCurrentUser();
    if (!signInDetails) {
      const decodedData = decodeToken(session);
      if (decodedData) {
        return {
          username: decodedData["cognito:username"],
          userId: decodedData["cognito:username"],
          signInDetails: {
            loginId: decodedData["email"],
            name: decodedData["name"],
          },
        };
      }
    }
    return { username, userId, signInDetails };
  } catch (err) {
  }
  return null;
}

export async function currentSession() {
  try {
    const { idToken } = (await fetchAuthSession()).tokens ?? {};
    const token = idToken?.toString() ?? null;
    return token;
  } catch (err) {
  }
  return null;
}

export async function currentSessionWithoutRefresh() {
  try {
    const { idToken } = (await fetchAuthSession()).tokens ?? {};
    const token = idToken?.toString() ?? null;
    return token;
  } catch (err) {
  }
  return null;
}

export async function currentSessionDecoded() {
  try {
    const { idToken } = (await fetchAuthSession()).tokens ?? {};
    const token = idToken?.toString() ?? null;
    if (token == null) {
      return null;
    }
    const userData = jwtDecode(token);
    return userData;
  } catch (err) {
  }

  return null;
}

export function decodeToken(token) {
  try {
    const userData = jwtDecode(token);
    return userData;
  } catch (err) {
  }

  return null;
}


export function isCaptain(userData) {
  return (
    userData["cognito:groups"] == null ||
    userData["cognito:groups"].includes("captain") ||
    userData["cognito:groups"].includes("bh_captain") ||
    userData["cognito:groups"].includes("qa_captain")
  );
}

export function isAdmin(userData) {
  return (
    userData["cognito:groups"] && userData["cognito:groups"].includes("admin")
  );
}

// Helper function to check if user has customer_service_international role
export function isCustomerServiceInternational(userData) {
  return (
    userData?.["cognito:groups"] && 
    userData["cognito:groups"].includes("customer_service_international")
  );
}

// Helper function to check if user has customer_service_domestic role
export function isCustomerServiceDomestic(userData) {
  return (
    userData?.["cognito:groups"] && 
    userData["cognito:groups"].includes("customer_service_domestic")
  );
}

// Helper function to get allowed route types based on user roles
// Returns: 'INL' for international only, 'DMC' for domestic only, 'ALL' for both
export function getAllowedRouteTypes(userData) {
  if (!userData?.["cognito:groups"]) return "ALL";
  
  const groups = userData["cognito:groups"];
  const isAdmin = groups.includes("admin");
  const hasInternational = groups.includes("customer_service_international");
  const hasDomestic = groups.includes("customer_service_domestic");
  
  // Admin has access to all
  if (isAdmin) return "ALL";
  
  // Check customer service roles
  if (hasInternational && hasDomestic) return "ALL";
  if (hasInternational) return "INL";
  if (hasDomestic) return "DMC";
  
  // Default: all access for other roles
  return "ALL";
}
